export const condiciones = [
  {Id:'C', Nombre: "EN CONSTRUCCION"},
  {Id:'N', Nombre: "NUEVO"},
  {Id:'U', Nombre: "USADO"},
]
